export default __webpack_public_path__ + "static/media/ermine_portrait.1dcf6082.png";